export default {
  apiBaseUrl: process.env.REACT_APP_API_URL || window._env_.REACT_APP_API_URL,
  appName: process.env.REACT_APP_APP_NAME || window._env_.REACT_APP_APP_NAME,
  theme: process.env.REACT_APP_THEME || window._env_.REACT_APP_THEME,
  img_url: process.env.REACT_APP_IMG_URL || window._env_.REACT_APP_IMG_URL,
}
